import React, { useState } from 'react'

import "../../styles/components/molecules/KeepUpdated.scss"

import { addUser } from '../../services/UserService';

import Input from '../atoms/Input';
import Loading from '../atoms/Loading';
import { emailRegex } from '../../util/validate';

const KeepUpdated = ({ content }) => {

  const [email, setEmail] = useState("");
  const [warning, setWarning] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const saveUser = async () => {
    setWarning("");
    setSuccess(false);
    setLoading(true);

    if (email.toLowerCase().match(emailRegex)) {
      addUser(email, "vacatures").then(result => {
        if (result === 409) {
          setWarning("Email is al aangemeld")
        } else {
          setEmail("")
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, 10000);
        }
        setLoading(false);
      })
    } else {
      setWarning("Vul een geldig email adres in")
      setLoading(false);
    }
  }

  return (
    <div className='keep-updated'>
          {
            (!success) ?
            (
              <h1 className='keep-updated-title'>
                {content.titel.split(" ").slice(0, -2).join(" ")}
                <span className='keep-updated-title--underline'>{content.titel.split(" ").slice(-2).join(" ")}</span>
              </h1>
            )
            :
            (
              <>
                <h1 className='keep-updated-title'>{content.succesTitel}</h1>
                <h2>{content.succesTekst}</h2>
              </>
            )
          }

      <p className='keep-updated-warning'>{warning}</p>
      <p className='keep-updated-success'>{success}</p>
      <div
        className={`keep-updated-input ${warning !== "" && "keep-updated-input--error"} ${success && "keep-updated-input--success"}`}
      >
            <Input
              name="email"
              onlyText={loading && true}
              placeholder={content.placeholder}
              value={email}
              onChange={(e) => {setEmail(e.target.value)}}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  saveUser(e);
                }
              }}
              onClick={(e) => { saveUser(e); }}
              success={success}
            />
            {
            (loading) &&
              (
              <Loading />
              )
          }
      </div>
    </div>
  )
}

export default KeepUpdated
